import BarChart from "../BarChart";
import LineChart from "../LineChart";
// import PieChart from "../PieChart";
import NewChart from "../NewChart";

const features = [
  {
    name: "Orders chart",
    description: "This chart shows the total number of orders in each month",
    component: <BarChart />,
  },
  {
    name: "Orders line chart",
    description:
      "This line chart is used to depict how the number of orders varies in the span of a year and the relative change of order amounts of different votures",
    component: <LineChart />,
  },
];

export default function Head() {
  return (
    <div className="bg-white">
      <div className="max-w-7xl mx-auto py-24 sm:py-32 sm:px-2 lg:px-4">
        <div className="max-w-2xl mx-auto px-4 lg:max-w-none">
          <div className="max-w-3xl">
            <p className="mt-2 text-3xl font-light tracking-tight text-sky-900 sm:text-4xl">
              EVD Management
            </p>
            <p className="mt-4 text-gray-500">
              Here are some graphs that tries to summarize the number of orders,
              loans and settlements
            </p>
          </div>

          <div className="space-y-16 pt-10 mt-10 border-t border-gray-200 sm:pt-16 sm:mt-16">
            {features.map((feature) => (
              <div
                key={feature.name}
                className="flex flex-col lg:grid lg:grid-cols-12 lg:gap-x-8 lg:items-center"
              >
                <div className="mt-6 lg:mt-0 lg:col-span-5 xl:col-span-4">
                  <h3 className="text-lg font-medium text-gray-900">
                    {feature.name}
                  </h3>
                  <p className="mt-2 text-sm text-gray-500">
                    {feature.description}
                  </p>
                </div>
                <div className="flex-auto lg:col-span-7 xl:col-span-8">
                  <div className="aspect-w-5 aspect-h-3 rounded-lg bg-gray-50 overflow-hidden">
                    {feature.component}
                  </div>
                </div>
              </div>
            ))}
            <div className="flex flex-col lg:grid lg:grid-cols-12 lg:gap-x-8 lg:items-center">
              <div className="mt-6 lg:mt-0 lg:col-span-5 xl:col-span-4">
                <h3 className="text-lg font-medium text-gray-900">
                  Loans and Settlements
                </h3>
                <p className="mt-2 text-sm text-gray-500 text-justify">
                  This chart contains the total number of loans and loan amounts
                  together with the total number of settlements with the total
                  settlements amount.
                </p>

                <p className="mt-3 text-sm text-gray-500 border-l-2 border-l-sky-400 pl-2 bg-sky-50 text-justify">
                  It can be filtered to a given time period
                </p>
              </div>
              <div className="mt-6 lg:mt-0 flex-auto lg:col-span-7 xl:col-span-8">
                <NewChart />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
